import { TransactionStatusAdapter } from '../../../adapter';

export default async function TransactionStatusUseCase(event) {
    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcr.dev.bpimsapps.com');
    const isUAT = url.includes('hcr.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionclaims.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
            ? "https://partners-api.dev.bpimsapps.com/payment/recurring/status"
            : isUAT
                ? "https://partners-api.uat.bpimsapps.com/payment/recurring/status"
                : isProd
                ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${flag ? '' : '/partners'}/payment/recurring/status`
                : `https://partners-api.${flag ? `${stage}.` : ''}bpimsapps.com/payment/recurring/status`;

    const payload = { 
        ...event
    };

    // handle request
    const result = await TransactionStatusAdapter(endpoint, JSON.stringify(payload));

    return result;
}
